import {
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Textarea,
  useDisclosure
} from '@chakra-ui/react'
import { Chart, registerables } from 'chart.js'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { FormModal } from '../../../components/FormModal'
import { Icon } from '../../../components/Icon'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'
import { NOT_APPLICABLE, StarRating } from '../../../components/StarRating'
import { useAppToast } from '../../../helpers'
import { IAceleraMagentaAnswer as IConexaoMagentaAnswer } from '../../../interfaces/IAceleraMagentaAnswer'
import ConexaoMagentaService from '../../../services/ConexaoMagenta/ConexaoMagentaService'

Chart.register(...registerables)

interface IFormField {
  id: number
  title: string
  type: string
  required: boolean
  options: string
  groups: string
}

export default function ConexaoMagentaQuestionsPage() {
  const toast = useAppToast()
  const conexaoMagentaService = new ConexaoMagentaService()
  const navigate = useNavigate()
  const id = parseInt(useParams().id as string)
  const [form, setForm] = useState<IFormField[]>([])
  const [formAnswers, setFormAnswers] = useState<IConexaoMagentaAnswer>({})
  const [saving, setSaving] = useState<boolean>(false)
  const modalViewAnswers = useDisclosure()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setSaving(true)

    // valida se todos os campos foram preenchidos
    let hasEmptyField = false
    form.map((field) => {
      if (field.type === 'title') return

      if (!formAnswers[field.id] || (formAnswers[field.id] === '0' && field.type === 'stars')) {
        hasEmptyField = true
        setSaving(false)
        return
      }
    })
    if (hasEmptyField) {
      toast.invalidForm('Preencha todos os campos antes de continuar.')
      setSaving(false)
      return
    }

    conexaoMagentaService.update(id, formAnswers).then((response) => {
      if (response.data.success) {
        navigate('/conexao-magenta/complete')
      }

      setSaving(false)
    })
  }

  const loadQuestions = async () => {
    conexaoMagentaService.getQuestions().then((response) => {
      setForm(response.data.questions)
    })
  }

  useEffect(() => {
    loadQuestions()
  }, [])

  return (
    <>
      <PublicFormLayout title="Conexão Magenta">
        <Heading as="h2" mb="4">
          Conexão e Diagnóstico
        </Heading>
        <form onSubmit={handleSubmit}>
          {form.map((field) => {
            return (
              <FormControl isRequired={field.type !== 'title'} key={field.id} mb="4">
                {field.title.replace(/\s/, '') && <FormLabel>{field.title}</FormLabel>}
                {field.type === 'textarea' && (
                  <Textarea
                    value={formAnswers[field.id]}
                    onChange={(event) => setFormAnswers({ ...formAnswers, [field.id]: event.target.value })}
                    height="180px"
                  />
                )}
                {field.type === 'date' && (
                  <Input
                    type="date"
                    value={formAnswers[field.id]}
                    onChange={(event) => setFormAnswers({ ...formAnswers, [field.id]: event.target.value })}
                  />
                )}
                {field.type === 'options' && (
                  <RadioGroup
                    value={formAnswers[field.id]}
                    onChange={(value) => setFormAnswers({ ...formAnswers, [field.id]: value })}
                  >
                    <Stack direction="column" spacing={3}>
                      {(JSON.parse(field.options) as string[]).map((option, index) => (
                        <Radio value={(index + 1).toString()} key={index}>
                          {option}
                        </Radio>
                      ))}
                    </Stack>
                  </RadioGroup>
                )}
                {field.type === 'checkbox' && (
                  <CheckboxGroup
                    value={formAnswers[field.id] ? JSON.parse(formAnswers[field.id]) : []}
                    onChange={(value) => setFormAnswers({ ...formAnswers, [field.id]: JSON.stringify(value) })}
                  >
                    {(JSON.parse(field.options) as string[]).map((option, index) => (
                      <Checkbox value={(index + 1).toString()} key={index} marginLeft="2">
                        {option}
                      </Checkbox>
                    ))}
                  </CheckboxGroup>
                )}
                {field.type === 'stars' && (
                  <Flex align="center" justify="space-between" gap="3">
                    <StarRating
                      label={field.title}
                      value={parseInt(formAnswers[field.id] ?? '0')}
                      onChange={(value) => setFormAnswers({ ...formAnswers, [field.id]: value.toString() })}
                    />
                    {!field.required && (
                      <Button
                        colorScheme="gray"
                        isActive={formAnswers[field.id] === String(NOT_APPLICABLE)}
                        type="button"
                        size={'xs'}
                        onClick={() =>
                          setFormAnswers({
                            ...formAnswers,
                            [field.id]: formAnswers[field.id] === String(NOT_APPLICABLE) ? '0' : String(NOT_APPLICABLE)
                          })
                        }
                      >
                        Não se aplica
                      </Button>
                    )}
                  </Flex>
                )}
              </FormControl>
            )
          })}

          <Button colorScheme="magenta" type="submit" disabled={saving}>
            Concluir &nbsp;
            <Icon name="lni lni-checkmark" />
          </Button>
        </form>
      </PublicFormLayout>

      <FormModal isOpen={modalViewAnswers.isOpen} onClose={modalViewAnswers.onClose} size="compact">
        {/*  <ConexaoMagentaViewPage aceleraMagentaId={id} skipLastStep={true} /> */}
      </FormModal>
    </>
  )
}
